export interface CallsCommunicationAuthorityRecord {
  readonly capability: string;
  readonly authority: string;
  readonly governed: boolean;
}

const CALLS_COMMUNICATION_AUTHORITIES: readonly CallsCommunicationAuthorityRecord[] =
Object.freeze([
  {
    capability: 'audio-call',
    authority: 'Calls Governor',
    governed: true,
  },
  {
    capability: 'video-call',
    authority: 'Calls Governor',
    governed: true,
  },
  {
    capability: 'group-call',
    authority: 'Calls Governor',
    governed: true,
  },
  {
    capability: 'incoming-call',
    authority: 'Calls Governor',
    governed: true,
  },
  {
    capability: 'outgoing-call',
    authority: 'Calls Governor',
    governed: true,
  },
  {
    capability: 'emergency-call',
    authority: 'Calls Governor',
    governed: true,
  },
]);

export function getCallsCommunicationAuthorities():
readonly CallsCommunicationAuthorityRecord[] {
  return CALLS_COMMUNICATION_AUTHORITIES;
}
